import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        name: true,
        token: localStorage.getItem('gdwtoken') || '',
        exp: localStorage.getItem('gdwexp') || '',
        language: localStorage.getItem('language') || 'zh',
        imgUrl: 'http://gdw.huisheng.net/',
        height: 120
    },
    mutations: {
        SET_LANGUAGE: (state, language) => {
            state.language = language
            localStorage.setItem('language', language)
        },
        SET_TOKEN: (state, token) => {
            state.token = token
            localStorage.setItem('gdwtoken', token);
        },
        SET_EXP: (state, exp) => {
            state.exp = exp
            localStorage.setItem('gdwexp', exp);
        },
        SET_NAME: (state, name) => {
            state.name = name
            localStorage.setItem('name', name);
        },
        SET_HEIGHT: (state, height) => {
            state.height = height
            localStorage.setItem('height', height);
        },
    },
    actions: {


    },
    getters: {
        token: state => {
            return state.token
        },
        exp: state => {
            return state.exp
        },
        language: state => {
            return state.language
        }
    }
})

export default store